import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import CommentCreateUpdateArg from './comment-create-update-arg-model'
import {
  CreateCommentCreateUpdateArgAsync,
  DeleteCommentCreateUpdateArgAsync,
  LoadCommentCreateUpdateArgsAsync,
} from './commentCreateUpdateArg-thunk'
const initialState: commentCreateUpdateArgSliceState = {
  commentCreateUpdateArg: [],
  selected_commentCreateUpdateArg: '',
  is_loading_commentCreateUpdateArg: false,
  is_creating_commentCreateUpdateArg: false,
  is_deleting_commentCreateUpdateArg: false,
}
export interface commentCreateUpdateArgSliceState {
  commentCreateUpdateArg: CommentCreateUpdateArg[]
  selected_commentCreateUpdateArg?: string
  is_loading_commentCreateUpdateArg: boolean
  is_creating_commentCreateUpdateArg: boolean
  is_deleting_commentCreateUpdateArg: boolean
}
export const commentCreateUpdateArgSlice = createSlice({
  name: 'commentCreateUpdateArg',
  initialState,
  reducers: {
    setSelectedcommentCreateUpdateArg: (state, action) => {
      state.selected_commentCreateUpdateArg = action.payload
    },
    clearStatecommentCreateUpdateArg: (state) => {
      state.commentCreateUpdateArg = []
      state.is_loading_commentCreateUpdateArg = false
      state.is_creating_commentCreateUpdateArg = false
      state.is_deleting_commentCreateUpdateArg = false
    },
    mergecommentCreateUpdateArg: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_commentCreateUpdateArg = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.commentCreateUpdateArg = merge(
            state.commentCreateUpdateArg,
            payload,
          ) as any
        }
      }
    },

    add_commentCreateUpdateArg: (state, action) => {
      if (action.payload) {
        state.commentCreateUpdateArg = [
          ...state.commentCreateUpdateArg,
          action.payload,
        ]
      }
    },
    set_commentCreateUpdateArg: (state, action) => {
      let { key, value, id } = action.payload
      state.commentCreateUpdateArg = state.commentCreateUpdateArg.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCommentCreateUpdateArgsAsync.pending, (state) => {
      state.is_loading_commentCreateUpdateArg = true
    })
    builder.addCase(
      LoadCommentCreateUpdateArgsAsync.fulfilled,
      (state, action) => {
        state.is_loading_commentCreateUpdateArg = false
        if (action.payload) {
          state.commentCreateUpdateArg = action.payload
        }
      },
    )
    builder.addCase(LoadCommentCreateUpdateArgsAsync.rejected, (state) => {
      state.is_loading_commentCreateUpdateArg = false
    })
    builder.addCase(CreateCommentCreateUpdateArgAsync.pending, (state) => {
      state.is_creating_commentCreateUpdateArg = true
    })
    builder.addCase(CreateCommentCreateUpdateArgAsync.fulfilled, (state) => {
      state.is_creating_commentCreateUpdateArg = false
    })
    builder.addCase(CreateCommentCreateUpdateArgAsync.rejected, (state) => {
      state.is_creating_commentCreateUpdateArg = false
    })
    builder.addCase(DeleteCommentCreateUpdateArgAsync.pending, (state) => {
      state.is_deleting_commentCreateUpdateArg = true
    })
    builder.addCase(
      DeleteCommentCreateUpdateArgAsync.fulfilled,
      (state, action) => {
        state.is_deleting_commentCreateUpdateArg = false
        if (state.commentCreateUpdateArg) {
          state.commentCreateUpdateArg = state.commentCreateUpdateArg.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteCommentCreateUpdateArgAsync.rejected, (state) => {
      state.is_deleting_commentCreateUpdateArg = false
    })
  },
})

export const {
  clearStatecommentCreateUpdateArg,
  setSelectedcommentCreateUpdateArg,
  set_commentCreateUpdateArg,
  mergecommentCreateUpdateArg,
  add_commentCreateUpdateArg,
} = commentCreateUpdateArgSlice.actions

export const get_commentCreateUpdateArg =
  (id?: string) =>
  (state: {
    commentCreateUpdateArg: {
      commentCreateUpdateArg: CommentCreateUpdateArg[]
    }
  }): CommentCreateUpdateArg | null => {
    let temp = state?.commentCreateUpdateArg?.commentCreateUpdateArg?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.commentCreateUpdateArg?.commentCreateUpdateArg[0] || null
  }
export const get_selected_commentCreateUpdateArg = (state: {
  commentCreateUpdateArg: commentCreateUpdateArgSliceState
}): CommentCreateUpdateArg | null => {
  let id = state?.commentCreateUpdateArg?.selected_commentCreateUpdateArg
  let temp = state?.commentCreateUpdateArg?.commentCreateUpdateArg?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_commentCreateUpdateArg = (state: {
  commentCreateUpdateArg: {
    commentCreateUpdateArg: CommentCreateUpdateArg[]
  }
}): CommentCreateUpdateArg[] => {
  let temp = state?.commentCreateUpdateArg?.commentCreateUpdateArg
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_commentCreateUpdateArg_busy = (state: {
  commentCreateUpdateArg: commentCreateUpdateArgSliceState
}) => {
  return (
    state?.commentCreateUpdateArg.is_deleting_commentCreateUpdateArg ||
    state?.commentCreateUpdateArg.is_loading_commentCreateUpdateArg ||
    state?.commentCreateUpdateArg.is_creating_commentCreateUpdateArg
  )
}
export const is_deleting_commentCreateUpdateArg_busy = (state: {
  commentCreateUpdateArg: commentCreateUpdateArgSliceState
}) => {
  return state?.commentCreateUpdateArg.is_deleting_commentCreateUpdateArg
}
export const is_loading_commentCreateUpdateArg_busy = (state: {
  commentCreateUpdateArg: commentCreateUpdateArgSliceState
}) => {
  return state?.commentCreateUpdateArg.is_loading_commentCreateUpdateArg
}
export const is_creating_commentCreateUpdateArg_busy = (state: {
  commentCreateUpdateArg: commentCreateUpdateArgSliceState
}) => {
  return state?.commentCreateUpdateArg.is_creating_commentCreateUpdateArg
}

export default commentCreateUpdateArgSlice.reducer
